(function () {
  document.addEventListener('DOMContentLoaded', function () {
    var wrap = document.querySelector('[data-te-set-buy]');
    if (!wrap) return;
    var btn = wrap.querySelector('[data-te-set-add-btn]');
    if (!btn || btn.disabled) return;

    var setVariantId = wrap.getAttribute('data-set-variant-id');
    var giftVariantId = wrap.getAttribute('data-gift-variant-id');

    btn.addEventListener('click', function () {
      if (btn.disabled || !setVariantId) return;

      var items = [{ id: setVariantId, quantity: 1 }];
      if (giftVariantId) items.push({ id: giftVariantId, quantity: 1 });

      var originalText = btn.textContent;
      btn.disabled = true;
      btn.textContent = 'Adding…';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: items,
          sections: ['cart-drawer', 'cart-icon-bubble'],
          sections_url: window.location.pathname,
        }),
      })
        .then(function (r) {
          return r.json();
        })
        .then(function (result) {
          if (result.status) {
            btn.textContent = result.description || 'Something went wrong — try again';
            btn.disabled = false;
            return;
          }

          btn.textContent = 'Added to cart ✓';

          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'takumi-set-buy', cartData: result });
          }

          var drawer = document.querySelector('cart-drawer');

          // Same pattern as takumi-build-your-own.js: prefer the theme's own renderer,
          // and explicitly clear is-empty (renderContents doesn't touch the wrapper class,
          // which otherwise keeps the drawer showing its empty state over a real total).
          if (drawer && result.sections && typeof drawer.renderContents === 'function') {
            drawer.classList.remove('is-empty');
            drawer.renderContents(result);
          } else {
            fetch('/cart.js', { headers: { Accept: 'application/json' } })
              .then(function (r) {
                return r.json();
              })
              .then(function (cart) {
                document.querySelectorAll('.cart-count-bubble span[aria-hidden]').forEach(function (el) {
                  el.textContent = cart.item_count;
                });
              });
            if (drawer && typeof drawer.open === 'function') drawer.open();
          }

          setTimeout(function () {
            btn.textContent = originalText;
            btn.disabled = false;
          }, 2200);
        })
        .catch(function () {
          btn.textContent = 'Something went wrong — try again';
          btn.disabled = false;
        });
    });
  });
})();
